interface OverwriteModalProps {
  show: boolean;
  fileName: string;
  onOverwrite: () => void;
  onOverwriteAll?: () => void;
  onSkip: () => void;
  onCancel: () => void;
}

export default function OverwriteModal({ show, fileName, onOverwrite, onOverwriteAll, onSkip, onCancel }: OverwriteModalProps) {
  if (!show) return null;

  return (
    <div className="modal d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }} onClick={onCancel}>
      <div className="modal-dialog modal-dialog-centered" onClick={e => e.stopPropagation()}>
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">
              <i className="bi bi-exclamation-triangle text-warning me-2" />
              Archivo existente
            </h5>
            <button type="button" className="btn-close" onClick={onCancel} />
          </div>
          <div className="modal-body">
            <p className="mb-2">
              Ya existe un archivo con el nombre:
            </p>
            <p className="fw-semibold text-primary mb-3">
              {fileName}
            </p>
            <p className="mb-0">
              ¿Qué deseas hacer?
            </p>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onSkip}>
              <i className="bi bi-skip-forward me-1" />
              Omitir
            </button>
            <button type="button" className="btn btn-warning" onClick={onOverwrite}>
              <i className="bi bi-arrow-repeat me-1" />
              Sobreescribir
            </button>
            {onOverwriteAll && (
              <button type="button" className="btn btn-danger" onClick={onOverwriteAll}>
                <i className="bi bi-arrow-repeat me-1" />
                Sobreescribir todo
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
